import * as React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { IconIntervention } from "./IconIntervention";
import { useSDK } from "../shared/useSDK";
import {
  Breadcrumb,
  BreadcrumbAligner,
  BreadcrumbLink,
} from "./lib/Breadcrumb";

const listLink = {
  to: "/interventions",
  text: "Interventions",
  icon: <IconIntervention />,
};

export function BreadcrumbIntervention() {
  const params = useParams<{ uuid?: string }>();
  return (
    <BreadcrumbAligner>
      <Breadcrumb>
        <BreadcrumbLink to={listLink.to}>
          {listLink.icon}
          <span>{listLink.text}</span>
        </BreadcrumbLink>
        {params.uuid ? <BreadcrumbItem /> : null}
      </Breadcrumb>
    </BreadcrumbAligner>
  );
}

function BreadcrumbItem() {
  const params = useParams<{ uuid: string }>();
  const { sdk } = useSDK();
  const result = useQuery(["intervention", params.uuid], (key, uuid: string) =>
    sdk.getIntervention({ interventionUuid: uuid })
  );
  const to = `/interventions/${params.uuid}`;
  const fallbackText = "Intervention";
  if (result.status === "loading") {
    return null;
  }
  if (result.status === "error" || result.data === undefined) {
    return <BreadcrumbLink to={to}>{fallbackText}</BreadcrumbLink>;
  }
  return <BreadcrumbLink to={to}>{result.data.data.name}</BreadcrumbLink>;
}
